module.exports = __webpack_public_path__ + "static/img/sf-item-05.57b7ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/sf-item-05.png
// module id = qcqT
// module chunks = 2